<i18n src="@/lang/actions.json"></i18n>
<i18n src="@/lang/messages.json"></i18n>

<template>
  <el-card shadow="hover">
    <div slot="header" class="clearfix">
      <el-row
        type="flex"
        class="row-bg align-center"
        :justify="val.gravatar ? 'space-between' : 'end'"
      >
        <v-gravatar v-if="val.gravatar" :size="35" :email="val.gravatar" />
        <el-button-group>
          <template v-for="(v, k) in val.actions">
            <template v-if="showBtn(v)">
              <template v-if="$slots[`actions.before.${k}`]">
                <slot :name="`actions.before.${k}`" />
              </template>
              <el-button
                :key="'btn' + k"
                :disabled="editMode && !cur_edit_mode"
                v-bind="v.props"
                @click="handleAction(val.actions[k].handler, k, val)"
              >
                {{ $t("actions." + k) }}
                <template v-if="v.button_els">
                  <component
                    v-for="(el, i) in v.button_els"
                    :is="el"
                    :key="i"
                  />
                </template>
              </el-button>
              <template v-if="$slots[`actions.after.${k}`]">
                <slot :name="`actions.after.${k}`" />
              </template>
            </template>
          </template>
        </el-button-group>
      </el-row>
    </div>
    <span>
      <el-form>
        <el-form-item v-for="(v, k) in val.schema" :key="k" :label="k">
          <template v-if="v.type === Boolean">
            <el-checkbox
              :disabled="!cur_edit_mode || !v.editable"
              v-model="val[k]"
            />
          </template>
          <template v-else>
            <span v-text="val[k]" v-if="!cur_edit_mode || !v.editable"></span>
            <el-input v-model="val[k]" v-else-if="v.editable"></el-input>
          </template>
        </el-form-item>
      </el-form>
    </span>
  </el-card>
</template>

<script>
export default {
  name: "sub-element",
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      }
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: this.value,
      cur_edit_mode: false
    };
  },
  watch: {
    val: {
      handler: function() {
        this.$emit("input", this.val);
      },
      deep: true
    },
    cur_edit_mode(v) {
      this.$emit("update:editMode", v);
    }
  },
  methods: {
    handleAction(handler, action_name, model) {
      let h = handler();
      if (h instanceof Promise) {
        h.then(param => {
          switch (param) {
            case "edit":
              this.cur_edit_mode = true;
              break;
            default:
              this.$emit("action", action_name, param, model);
              this.cur_edit_mode = false;
          }
          // this.cur_edit_mode = !!param;
          // this.cur_edit_mode = !!param || false;
          this.$emit("update:editMode", this.cur_edit_mode);
        });
      }
    },
    showBtn(v) {
      return this.cur_edit_mode === v.in_edit_mode;
    }
  }
};
</script>

<style scoped lang="stylus">
.card-contact, .card-amo, .card-customer {
    min-width: 400px;
    display: flex;
    flex-direction: column;
    margin-bottom: 2rem;
}

.row-bg {
    flex-wrap: wrap;
}
</style>
